import { Component } from '@angular/core';
import { map, Observable } from 'rxjs';

import { CompatibilityService } from '../../../services/compatibility.service';
import { MachineType } from '../../../models/machine-type.interface';
import { ResponsiveService } from 'src/app/services/responsive.service';
import { TranslateModule } from '@ngx-translate/core';
import { NgFor, NgClass, AsyncPipe } from '@angular/common';
import { CompatibilityCardComponent } from '../../shared/compatibility-card/compatibility-card.component';

@Component({
    selector: 'app-equipment-selection',
    templateUrl: './equipment-selection.component.html',
    styleUrls: ['./equipment-selection.component.scss'],
    standalone: true,
    imports: [
        CompatibilityCardComponent,
        NgFor,
        NgClass,
        AsyncPipe,
        TranslateModule,
    ],
})
export class EquipmentSelectionComponent {
  selectedEquipment$: Observable<MachineType | null>;
  firstLine$: Observable<MachineType[]>;
  secondLine$: Observable<MachineType[]>;
  thirdLine$: Observable<MachineType[]>;

  constructor(
    private compatibilityService: CompatibilityService,
    private responsiveService: ResponsiveService
  ) {
    this.selectedEquipment$ = this.compatibilityService.selectedEquipment$;

    this.firstLine$ = this.responsiveService.width$.pipe(
      map((width) => {
        if (this.isBigScreen(width)) {
          return [...this.compatibilityService.machineTypes].splice(0, 3);
        }
        if (this.isMediumScreen(width)) {
          return [...this.compatibilityService.machineTypes].splice(0, 2);
        }
        return [...this.compatibilityService.machineTypes];
      })
    );
    this.secondLine$ = this.responsiveService.width$.pipe(
      map((width) => {
        if (this.isBigScreen(width)) {
          return [...this.compatibilityService.machineTypes].splice(3, 2);
        }
        if (this.isMediumScreen(width)) {
          return [...this.compatibilityService.machineTypes].splice(2, 2);
        }
        return [];
      })
    );
    this.thirdLine$ = this.responsiveService.width$.pipe(
      map((width) => {
        if (this.isMediumScreen(width)) {
          return [...this.compatibilityService.machineTypes].splice(4, 1);
        }
        return [];
      })
    );
  }

  onSelectEquipment(choice: number): void {
    this.compatibilityService.selectEquipment(choice);
  }

  private isBigScreen(width: number): boolean {
    return width > 1222;
  }

  private isMediumScreen(width: number): boolean {
    return width > 1157 && width <= 1222;
  }
}
